import type { TourStep } from '../types';

export const addingLicenseSteps: TourStep[] = [
  {
    target: '[data-tour="profile-license"]',
    title: 'License & Verification',
    content:
      'Your appraiser license is the key to unlocking the full platform. Let\'s get it entered and verified.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="profile-license"]',
    title: 'Enter Your License Number',
    content:
      'Type your NJ license number exactly as it appears on your state certificate, then set your expiration date. Ashlar validates it against the NJ licensing database.',
    placement: 'bottom',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I\'ve entered it',
  },
  {
    target: 'a[href="/dashboard"]',
    title: 'Verification Status',
    content:
      'Once submitted, an admin reviews your license. You\'ll see a "Verified" badge on your dashboard when approved. Until then, some features like creating appraisals may be restricted.',
    placement: 'right',
    spotlightClicks: true,
  },
  {
    target: '[data-tour="sidebar-badge"]',
    title: 'Your Role Badge',
    content:
      'After verification, your sidebar shows your role — Appraiser, Trainee, or Admin. This confirms your license is active and you have full platform access.',
    placement: 'right',
  },
];
